module.exports = __webpack_public_path__ + "img/fig27.e8fa4d36.jpg";